import { HS_EMAIL_ADDRESS } from 'conversations-message-history/common-message-format/constants/deliveryIdentifierTypes';
export const deliveryIdentifierTypeToContact = {
  ['email']: HS_EMAIL_ADDRESS
};